
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-[#1e3a5f] text-white py-16 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Name */}
          <div>
            <h5 className="text-xl font-semibold mb-4">
              S&amp;L Contractors of Alabama, Inc.
            </h5>
            <p className="text-sm text-gray-300 leading-relaxed">
              Professional{' '}
              <strong className="text-gray-200 font-normal">
                residential contractor
              </strong>{' '}
              with over 20 years of experience in{' '}
              <strong className="text-gray-200 font-normal">
                home improvement
              </strong>
              , remodeling &amp; repair services in Mobile &amp; Baldwin Counties
              AL.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h6 className="text-lg font-semibold mb-4">Quick Links</h6>
            <nav aria-label="Footer navigation">
              <div className="space-y-2">
                <Link
                  to="/"
                  className="block text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Home
                </Link>
                <Link
                  to="/services"
                  className="block text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Services
                </Link>
                <Link
                  to="/gallery"
                  className="block text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Gallery
                </Link>
                <Link
                  to="/contact"
                  className="block text-sm text-gray-300 hover:text-white transition-colors"
                >
                  Contact
                </Link>
              </div>
            </nav>
          </div>

          {/* Location & Hours */}
          <div>
            <h6 className="text-lg font-semibold mb-4">Location &amp; Hours</h6>
            <address className="not-italic">
              <p className="text-sm text-gray-300 mb-2">Mobile, AL 36609</p>
              <p className="text-sm text-gray-300">Mon-Sat 8:00 AM to 8:00 PM</p>
            </address>
          </div>

          {/* Contact Us */}
          <div>
            <h6 className="text-lg font-semibold mb-4">Contact Us</h6>
            <address className="not-italic">
              <p className="text-sm text-gray-300 mb-2">
                <i className="ri-mail-line mr-2"></i>
                <a
                  href="mailto:SL.Contractors.AL@gmail.com"
                  className="text-gray-300 hover:text-white"
                >
                  SL.Contractors.AL@gmail.com
                </a>
              </p>
              <p className="text-sm text-gray-300 mb-1">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:251-348-8514" className="text-gray-300 hover:text-white">
                  251-348-8514
                </a>
              </p>
              <p className="text-sm text-gray-300 mb-4">
                <i className="ri-phone-line mr-2"></i>
                <a href="tel:251-454-1737" className="text-gray-300 hover:text-white">
                  251-454-1737
                </a>
              </p>
            </address>
            <a
              href="https://www.facebook.com/profile.php?id=61551840254912"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center justify-center w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300"
              aria-label="Visit S&L Contractors on Facebook"
            >
              <i className="ri-facebook-fill text-xl"></i>
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/20 pt-8">
          <p className="text-sm text-gray-400 text-center">
            © {new Date().getFullYear()} S&amp;L Contractors of Alabama, Inc. All
            rights reserved.
          </p>
          <p className="text-[10px] text-gray-500 text-center mt-3">
            Powered by{' '}
            <a
              href="https://nextgearwebservices.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300"
            >
              NextGear Web Services
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
